import Icon from "@Components/generic/icon";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Stack, useTheme } from "@mui/material";

interface IIconTag {
  icon: IconDefinition;
}

const IconTag = ({ icon }: IIconTag) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        padding: theme.spacing(1.75),
        backgroundColor: "dsSurface.v300",
        height: 64,
        width: 64,
        cornerShape: "squircle",
        borderRadius: "32px",
        overflow: "hidden",
        justifyContent: "center",
        boxSizing: "border-box",
      }}
    >
      <Icon icon={icon} color={theme.palette.dsNeutral.v400} size="2xl" />
    </Stack>
  );
};

export default IconTag;
